import './contactForm.css'

export default function ContactForm(){
    return <>
        <div className="contact-box">
            <form>
                <p className="info">Les champs indiqués par un astérisque (*) sont obligatoires</p>

                <div className="two-columns">
                    <div className="form-group">
                        <label htmlFor="contact-name">Nom*</label>
                        <input id="contact-name" name="name" type="text" required aria-required="true" />
                    </div>

                    <div className="form-group">
                        <label htmlFor="contact-firstname">Prénom</label>
                        <input id="contact-firstname" name="firstname" type="text" />
                    </div>
                </div>

                <div className="two-columns">
                    <div className="form-group">
                        <label htmlFor="contact-phone">Téléphone*</label>
                        <input id="contact-phone" name="phone" type="text" required aria-required="true" />
                    </div>

                    <div className="form-group">
                        <label htmlFor="contact-email">Email*</label>
                        <input id="contact-email" name="email" type="email" required aria-required="true" />
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="contact-message">Message*</label>
                    <textarea id="contact-message" name="message" required aria-required="true"></textarea>
                </div>

                <div className="checkbox-area">
                    <input id="contact-consent" type="checkbox" required aria-required="true" />
                    <label htmlFor="contact-consent">
                        En soumettant ce formulaire, j'accepte que mes informations soient traitées selon la politique de confidentialité.
                    </label>
                </div>

                <button type="submit" className="send-btn">Envoyer</button>
            </form>
        </div>
    </>
}